<template>
    <v-dialog v-model="switchWarning" :max-width="$vuetify.breakpoint.mobile ? '100%' : '30%'">
              <v-card>
                <v-card-title><v-icon left color="warning">$warn</v-icon> {{ $t(title) }}</v-card-title>
                <v-card-text>
                    <slot>{{$t('dialog.dangerous.text')}}</slot>
                </v-card-text>
                <v-card-actions>
                  <v-btn id="pfid1618852432" :text="buttonText" :color="buttonColor" @click="$emit('confirm')" :loading="saving"><v-icon left>{{ buttonIcon }}</v-icon> {{ $t(buttonCaption) }}</v-btn>
                  <v-btn id="pfid1618852436" text @click="switchWarning = false; $emit('cancel')"><v-icon left>$close</v-icon>{{$t('dialog.cancel')}}</v-btn>
                </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
export default {
    name: 'ConfirmDialog',
    props: { value: Boolean, title: { type: String, default: 'dialog.dangerous.title' }, buttonCaption: {type: String, default: 'dialog.confirm' }, saving: Boolean, buttonColor:  {type: String, default: 'warning' }, buttonIcon: {type: String, default: '$warn' }, buttonText: { type: Boolean, default: true }},
    /*
    data() {
        return {
            switchWarning: this.value
        }
    }
    */
   computed: {
       switchWarning: {
           get() {
               return this.value;
           },
           set(val) {
               this.$emit('input', val);
           }
       }
   }
}
</script>